import {Injectable} from '@angular/core';
import {BaseService} from '../../../../core/service/base.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';

import {catchError, tap} from 'rxjs/operators';


export const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  withCredentials: true,
};

@Injectable({
  providedIn: 'root'
})
export class SupplierRegisterService extends BaseService {
  step:number = 0;
  again:number = 0;
  supBasicInfo:any = {};
  email:any = null;
  phone:any = null;
  supplierName:any = null;
  company:boolean=true;

  againSend = true;
  inviteCheckKey:any = null;
  countryId:any = null;
  public chinaCountryId:any = null;//中国id
  public defaultCountryId:any = null;//默认国家id
  public suppleInfoBaseInfo:any = {};//补充信息中的基本信息

  public supAddressInfo:any = {};//补充信息中的地址信息

  public supContactInfo:any = {};//补充信息中的联系人信息

  public supManager:any={};

  public supTreeKey:any = [];//补充信息中的品类
  public supLicense:any = {};//补充信息中的营业执照表单
  public supLicenseFile:any = [];


  private beforeLogin='api/before-login';
  constructor(http:HttpClient) {
    super(http);
  }

  getUrl():string {
    return "api/supplier/check-dup?_allow_anonymous=true";
  }

    //验证邮箱是否存在
    checkEmail(params):Observable<any> {
      let url=this.beforeLogin+`/check-email/?_allow_anonymous=true&email=${params}`;
      return this.http.get<any>(url).pipe(
        tap(_ => this.log(`checkEmail`)),
        catchError(this.handleError<any>(`checkEmail`))
      );
    }

    //判断手机是否存在
    checkPhone(params):Observable<any> {
      let url=this.beforeLogin+`/check-phone/?_allow_anonymous=true&phone=${params}`;
      return this.http.get<any>(url).pipe(
        tap(_ => this.log(`checkPhone`)),
        catchError(this.handleError<any>(`checkPhone`))
      );
    }
  validation(params):Observable<any> {
    return this.http.get(this.getUrl(),
      {
        headers: httpOptions.headers,
        params: params
      }
    ).pipe(
      tap(() => this.log('getModule')),
      catchError(this.handleError('getModule'))
    );
  }

  send(object:any):Observable<any> {
    return this.http.post<any>('api/supplier/create-by-supplier?_allow_anonymous=true', object, httpOptions).pipe(
      tap((object:any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany'))
    );
  }

  againSendEmail(object:any):Observable<any> {
    return this.http.post<any>('api/before-login/resend?_allow_anonymous=true', object, httpOptions).pipe(
      tap((object:any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany'))
    );
  }

  registEmail(object:any):Observable<any> {
    return this.http.post<any>('api/before-login/regist-resend?_allow_anonymous=true', object, httpOptions).pipe(
      tap((object:any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany'))
    );
  }


  getText(params):Observable<any> {
    return this.http.get('api/before-login/get-article-by-place?_allow_anonymous=true',
      {
        headers: httpOptions.headers,
        params: params
      }
    ).pipe(
      tap(() => this.log('getModule')),
      catchError(this.handleError('getModule'))
    );
  }


  getPurorg():Observable<any[]> {
    const url = `api/purorg/all?_allow_anonymous=true`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>(`getAll`))
    );
  }

  getSupplyAll(param?):Observable<any[]> {
    let params:any = {};
    if(param){
      params = param;
    }
    params.page = 0;
    params.size = 10000;
    const url = `api/supply-type/find-all-tree?_allow_anonymous=true`;
    return this.http.get<any>(url,{params:params}).pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>(`getAll`))
    );
  }


  getCountry():Observable<any[]> {
    const url = `api/country/all?_allow_anonymous=true`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>(`getAll`))
    );
  }

  private provinceUrl = 'api/region/find-by-country-id?_allow_anonymous=true';

  getProvince(id):Observable<any> {
    return this.http.get<any>(this.provinceUrl, {params: {countryId: id}}).pipe(
      tap(_ => this.log(`get province id=${id}`)),
      catchError(this.handleError<any>(`get province id=${id}`))
    );
  }

  //  根据省份获取对应相应的城市
  private cityUrl = 'api/city/find-by-region-id?_allow_anonymous=true';

  getCity(id):Observable<any> {
    return this.http.get<any>(this.cityUrl, {params: {regionId: id}}).pipe(
      tap(_ => this.log(`get city id=${id}`)),
      catchError(this.handleError<any>(`get city id=${id}`))
    );
  }


  /**
   * 根据主表code获取明细列表
   * @param type
   * @returns {Observable<any|any>}
   */
  getWithItemList(dictCode):Observable<any> {
    const url = `api/dict-tables/search-with-list?_allow_anonymous=true`;
    return this.http.get<any>(url, {params: {dictCode: dictCode}}).pipe(
      tap(_ => this.log(`getWithItemList`)),
      catchError(this.handleError<any>(`getWithItemList`))
    );
  }

  getArticle(params):Observable<any> {
    return this.http.get('api/before-login/category?_allow_anonymous=true',
      {
        headers: httpOptions.headers,
        params: params
      }
    ).pipe(
      tap(() => this.log('getModule')),
      catchError(this.handleError('getModule'))
    );
  }

  getArticleDetail(params):Observable<any> {
    return this.http.get('api/before-login/search-article?_allow_anonymous=true',
      {
        headers: httpOptions.headers,
        params: params
      }
    ).pipe(
      tap(() => this.log('getModule')),
      catchError(this.handleError('getModule'))
    );
  }

  searchArticleDetail(params):Observable<any> {
    return this.http.get('api/before-login/search-article-by-title?_allow_anonymous=true',
      {
        headers: httpOptions.headers,
        params: params
      }
    ).pipe(
      tap(() => this.log('getModule')),
      catchError(this.handleError('getModule'))
    );
  }
  getNewsDetails(id:any):Observable<any> {
    const url = `api/before-login/get-article/${id}?_allow_anonymous=true`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object id=${id}`)),
      catchError(this.handleError<any>(`getany id=${id}`))
    );
  }

  getTenderMat(id:any):Observable<any> {
    const url = `api/before-login/get-tenderMat/${id}?_allow_anonymous=true`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object id=${id}`)),
      catchError(this.handleError<any>(`getany id=${id}`))
    );
  }

  /**
   * 未登录状态根据明细表typeCode获取明细列表
   * @param type
   * @returns {Observable<any|any>}
   */
  getWithItemListBeforeLogin(typeCode):Observable<any> {
    const url = `api/config-para-dt/search-code-bef-login?_allow_anonymous=true`;
    return this.http.get<any>(url, {params: {typeCode:typeCode}}).pipe(
      tap(_ => this.log(`getWithItemListBeforeLogin`)),
      catchError(this.handleError<any>(`getWithItemListBeforeLogin`))
    );
  }


//  根据checkKey获取邀请信息
 getByCheckKey(checkKey):Observable<any> {
  const url = `api/sup-invite/get-by-check-key?_allow_anonymous=true`;
  return this.http.get<any>(url, {params: {inviteCheckKey:checkKey}}).pipe(
    tap(_ => this.log(`getByCheckKey`)),
  catchError(this.handleError<any>(`getByCheckKey`))
);
}

  /**
   * 根据主表mainCode获取明细列表
   * @param type
   * @returns {Observable<any|any>}
   * 获取系统参数
   */
  getSystemParam(mainCode):Observable<any> {
    const url = `api/config-para/search-with-list?_allow_anonymous=true`;
    return this.http.get<any>(url, {params: {mainCode:mainCode}}).pipe(
      tap(_ => this.log(`getWithItemList`)),
      catchError(this.handleError<any>(`getWithItemList`))
    );
  }

  /**
   * 手机验证码注册接口
   */
  //发送手机验证码
  activeCheckPhone(phoneNumber){
    const url= `api/before-login/active-check-phone?_allow_anonymous=true`;
    return this.http.get<any>(url,{params: {phone:phoneNumber}}).pipe(
      tap(_ => this.log(`activeCheckPhone`)),
      catchError(this.handleError<any>(`activeCheckPhone`))
    )
  }

//  手机号码注册
  activePhone(object: any): Observable<any> {
    const url = `api/before-login/active-phone?_allow_anonymous=true`;
    return this.http.post<any>(url, object, httpOptions).pipe(
      tap((object: any) => this.log(`activePhone`)),
      catchError(this.handleError<any>('activePhone')),
    );
  }

}
